import React from 'react'
import { Text, csx, cx } from '@vtex/admin-ui'
import type { TextProps } from '@vtex/admin-ui'

export type SalesAssociateCardNameProps = TextProps

export const SalesAssociateCardName = ({
  className = '',
  ...props
}: SalesAssociateCardNameProps) => (
  <Text className={cx(csx({ fontWeight: '600' }), className)}>
    {props.children}
  </Text>
)
